import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import {
  SetWidgetBarLocationRequest,
  SetWidgetBarLocationResponse
} from './setWidgetBarLocation.types'

export const setWidgetBarLocation = async (
  data: SetWidgetBarLocationRequest
) => {
  const response = await containerApi.post<SetWidgetBarLocationResponse>(
    '/desktop/widget-bar-location',
    data
  )
  return response.data
}

export const useSetWidgetBarLocationMutation = (
  options?: ExtendableMutationOptions<
    SetWidgetBarLocationResponse,
    SetWidgetBarLocationRequest
  >
) => {
  return useMutation({
    mutationFn: setWidgetBarLocation,
    ...options
  })
}
